export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        generalData: [],
        menu: []
    },
    // -----------------------------------------------------------------
    getters: {
        generalData: state => {
            return state.generalData;
        },
        menu: state => {
            return state.menu;
        },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_GENERALDATA(state, generalData) {
            state.generalData = generalData;
        },
        SET_MENU(state, menu) {
            state.menu = menu;
        }
    },
    // -----------------------------------------------------------------
    actions: {
        getMenu({ commit, rootState }) {
            return rootState.api
                .get(`/api/menu?locale=${document.documentElement.lang}`)
                .then(response => {
                    commit("SET_MENU", response.data);
                    return Promise.resolve(response.data);
                })
                .catch(e => {
                    return Promise.reject(e);
                });
        },
        getGeneralData({ commit, rootState }) {
            return rootState.api
                .get(`/api/general?locale=${document.documentElement.lang}`)
                .then(response => {
                    commit("SET_GENERALDATA", response.data);
                    return Promise.resolve(response.data);
                })
                .catch(e => {
                    return Promise.reject(e);
                });
        },
    }
};
